import type {
  RestoreEksNamespaceVolumeInput,
  Account,
  InventoryResource,
  Snapshot,
} from '@repo/api-gw-sdk';
import { Provider } from '@repo/api-gw-sdk';

import type { Encryption } from '@/components/encryption/encryptionComponent';

import type { RestoreGenericStorageProps } from './bucketSelection';
import { EksNamespaceConfiguration } from './steps/eksNamespaceConfiguration';
import { EksVolumesConfiguration } from './steps/eksVolumesConfiguration';
import { SelectTargetAccountStep } from './steps/selectTargetAccount';

import type { Step } from '../wizard/Step';
import { Wizard } from '../wizard/Wizard';

export interface RestoreEKSNamespaceState extends RestoreGenericStorageProps {
  resource: InventoryResource;
  snapshot: Snapshot;
  supportedCloudProviders: Provider[];
  restoreAccount?: Account;
  volumes: RestoreEksNamespaceVolumeInput[];
  prefix?: string;
  sharedEncryption?: Encryption;
}

const restoreEKSNamespaceFlow: Step<RestoreEKSNamespaceState> = {
  name: 'SelectTargetAccountStep',
  Component: SelectTargetAccountStep,
  next: [
    {
      name: 'EksNamespaceConfiguration',
      Component: EksNamespaceConfiguration,
      next: [
        {
          name: 'EksVolumesConfiguration',
          Component: EksVolumesConfiguration,
        },
      ],
    },
  ],
};

export const RestoreEksNamespaceWizard = ({
  resource,
  snapshot,
  onClose,
  onBack,
}: {
  resource: InventoryResource;
  snapshot: Snapshot;
  onClose: () => void;
  onBack: () => void;
}) => {
  return (
    <Wizard<RestoreEKSNamespaceState>
      onAbort={(origin) => (origin === 'back' ? onBack() : onClose())}
      onFinish={async () => true}
      flow={[restoreEKSNamespaceFlow]}
      initialState={{
        snapshot,
        resource,
        supportedCloudProviders: [Provider.Aws],
        S3: {},
        GCS: {},
        StorageAccount: {},
        region: resource.region,
        volumes: [], // in eks namespace we don't get the volumes from the list snapshots
      }}
      title='Restore EKS Namespace'
      stepperLabels={[
        'Restore Account',
        'Artifacts Restore Configuration',
        'Volumes Configuration',
      ]}
    />
  );
};
